import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 200,
    height: 36,
  },
  frame: {
    fill: '#09243f',
  },
  accent: {
    fill: '#f4b942',
  },
  text: {
    fill: '#f7fafc',
    fontSize: 18,
    fontWeight: 700,
    letterSpacing: 1,
    fontFamily: 'Arial, sans-serif',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 36">
      <rect className={classes.frame} x="0" y="2" rx="10" ry="10" width="200" height="32" />
      <rect className={classes.accent} x="10" y="10" rx="5" ry="5" width="26" height="16" />
      <text className={classes.text} x="48" y="23">
        C4CI Portal
      </text>
    </svg>
  );
};
